import React from 'react'
import PropTypes from 'prop-types'
import LargeTrianglesRight from '../../assets/images/decoratives/largeTriangles-right.inline.svg'
import SmallTrianglesRight from '../../assets/images/decoratives/smallTriangles-right.inline.svg'
import SmallTrianglesLeft from '../../assets/images/decoratives/smallTriangles-left.inline.svg'
import LatticeRight from '../../assets/images/decoratives/lattice-right.inline.svg'
import LatticeLeft from '../../assets/images/decoratives/lattice-left.inline.svg'
import SlashesRight from '../../assets/images/decoratives/slashes-right.inline.svg'
import SlashesLeft from '../../assets/images/decoratives/slashes-left.inline.svg'
import SlashStackRight from '../../assets/images/decoratives/slashStack-right.inline.svg'
import SlashStackLeft from '../../assets/images/decoratives/slashStack-left.inline.svg'

function DecorationV3({ data, ods }) {
  const { shape, color, alignment, appearsOnMobile } = data
  const colorLower = color.toLowerCase()
  const slashesMobile = appearsOnMobile ? (
    <div className={`mobile-diagonals-lines-${colorLower}`} />
  ) : null
  const trianglesMobile = appearsOnMobile ? (
    <div className={`mobile-triangle-${colorLower}`} />
  ) : null
  const latticeMobile = appearsOnMobile ? <div className={`mobile-lattice-${colorLower}`} /> : null
  let decorationClass = `decoration__${alignment.toLowerCase()} ${colorLower}`
  let svg
  // switch case makes sense for now based on limited shapes for decoration
  // if we add more shapes down the road we should add logic to parse the shape name and determine svg based off that
  switch (shape) {
    case 'Lattice':
      decorationClass = `lattice__${colorLower} ${decorationClass}`
      svg =
        alignment === 'Right' ? (
          <>
            <LatticeRight className={decorationClass} />
            {latticeMobile}
          </>
        ) : (
          <>
            <LatticeLeft className={decorationClass} />
            {latticeMobile}
          </>
        )
      break
    case 'Diagonal Lines Stack':
      svg =
        alignment === 'Right' ? (
          <>
            <SlashStackRight className={decorationClass} />
            {slashesMobile}
          </>
        ) : (
          <>
            <SlashStackLeft className={decorationClass} />
            {slashesMobile}
          </>
        )
      break
    case 'Small Triangles':
      decorationClass = `small-triangles ${decorationClass}`
      svg =
        alignment === 'Right' ? (
          <>
            <SmallTrianglesRight className={decorationClass} />
            {trianglesMobile}
          </>
        ) : (
          <>
            <SmallTrianglesLeft className={decorationClass} />
            {trianglesMobile}
          </>
        )
      break
    case 'Diagonal Lines':
      svg =
        alignment === 'Right' ? (
          <>
            <SlashesRight className={decorationClass} />
            {slashesMobile}
          </>
        ) : (
          <>
            <SlashesLeft className={decorationClass} />
            {slashesMobile}
          </>
        )
      break
    case 'Large Triangles':
      svg = (
        <>
          <LargeTrianglesRight
            className={`large-triangles large ${decorationClass} ${ods ? 'new-height' : null}`}
          />
          {trianglesMobile}
        </>
      )
      break
    default:
      break
  }
  return svg
}

DecorationV3.defaultProps = {
  data: {},
  ods: false
}

DecorationV3.propTypes = {
  data: PropTypes.object,
  ods: PropTypes.bool
}

export default DecorationV3
